/* Creed Fashion — exit-intent okno (samo namizje).
   Pokaže se enkrat na sejo, ko gre miška proti vrhu okna in ima kupec
   kaj v košarici. Ponudi kodo CREED7 (7 %), razen če je že pripet
   bonus TRIO5 — takrat samo opomni, da bonus še čaka. */
(function () {
  'use strict';
  if (window.Shopify && Shopify.designMode) return;
  var FLAG = 'creedExitShown';
  try { if (sessionStorage.getItem(FLAG)) return; } catch (e) { return; }
  if (window.matchMedia && window.matchMedia('(hover: none)').matches) return; // brez namizne miške ni exit-intenta

  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var CODE = 'CREED7';

  var lang = (document.documentElement.lang || 'sl').slice(0, 2).toLowerCase();
  if (lang !== 'hr' && lang !== 'en') lang = 'sl';

  var T = {
    sl: {
      header: 'POČAKAJ ŠE MALO',
      title: 'Tvoja košarica te še čaka.',
      body: 'Vzemi <b>7 % popusta</b> na celotno naročilo — kodo pripnemo samodejno, obračuna se na blagajni.',
      bodyTrio: 'Tvoj <b>bonus 5 %</b> je še vedno pripet in se obračuna na blagajni. Ne pusti ga propasti.',
      cta: 'Vzemi 7 % in poglej košarico',
      ctaTrio: 'Dokončaj nakup',
      no: 'Ne, hvala'
    },
    hr: {
      header: 'PRIČEKAJ TRENUTAK',
      title: 'Tvoja košarica te još čeka.',
      body: 'Uzmi <b>7 % popusta</b> na cijelu narudžbu — kod dodajemo automatski, obračunava se na blagajni.',
      bodyTrio: 'Tvoj <b>bonus od 5 %</b> je još uvijek dodan i obračunava se na blagajni.',
      cta: 'Uzmi 7 % i pogledaj košaricu',
      ctaTrio: 'Dovrši kupnju',
      no: 'Ne, hvala'
    },
    en: {
      header: 'WAIT A SECOND',
      title: 'Your cart is still waiting.',
      body: 'Take <b>7% off</b> your entire order — the code is attached automatically and applied at checkout.',
      bodyTrio: 'Your <b>5% bonus</b> is still attached and will be applied at checkout.',
      cta: 'Take 7% & view cart',
      ctaTrio: 'Finish your order',
      no: 'No, thanks'
    }
  }[lang];

  var CSS = '' +
    '.creed-exit-overlay{position:fixed;inset:0;background:rgba(0,0,0,.62);z-index:2147483001;display:flex;align-items:center;justify-content:center;padding:16px;opacity:0;transition:opacity .25s ease;}' +
    '.creed-exit-overlay.is-open{opacity:1;}' +
    '.creed-exit{background:#fff;color:#1d1d1f;width:100%;max-width:440px;border-radius:var(--img-rounded,6px);box-shadow:0 20px 60px rgba(0,0,0,.35);overflow:hidden;transform:translateY(14px);transition:transform .25s ease;font-family:var(--body-font-family,inherit);}' +
    '.creed-exit-overlay.is-open .creed-exit{transform:none;}' +
    '.creed-exit__head{background:#1d1d1f;color:#fff;display:flex;align-items:center;justify-content:space-between;padding:14px 18px;}' +
    '.creed-exit__title{font-weight:700;letter-spacing:.14em;font-size:1.4rem;}' +
    '.creed-exit__close{background:transparent;border:1px solid rgba(255,255,255,.5);color:#fff;width:30px;height:30px;border-radius:4px;cursor:pointer;font-size:1.6rem;line-height:1;}' +
    '.creed-exit__body{padding:20px 18px 18px;}' +
    '.creed-exit__h{font-size:1.8rem;font-weight:700;margin:0 0 8px;}' +
    '.creed-exit__p{font-size:1.4rem;line-height:1.55;margin:0 0 16px;color:#55524c;}' +
    '.creed-exit__btn{display:block;width:100%;background:var(--btn-primary-bg-color,#1d1d1f);color:var(--btn-primary-color,#fff);border:0;border-radius:var(--btn-radius,4px);padding:13px 16px;font-size:1.4rem;font-weight:700;cursor:pointer;letter-spacing:.03em;}' +
    '.creed-exit__btn:hover{opacity:.85;}' +
    '.creed-exit__no{display:block;text-align:center;margin-top:12px;font-size:1.2rem;color:#75716a;text-decoration:underline;cursor:pointer;background:none;border:0;width:100%;}';

  function hasTrio() {
    return /(^|;\s*)discount_code=TRIO5(;|$)/.test(document.cookie || '');
  }

  function show() {
    try { sessionStorage.setItem(FLAG, '1'); } catch (e) {}

    var style = document.createElement('style');
    style.textContent = CSS;
    document.head.appendChild(style);

    var trio = hasTrio();
    var overlay = document.createElement('div');
    overlay.className = 'creed-exit-overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.innerHTML =
      '<div class="creed-exit">' +
      '<div class="creed-exit__head"><span class="creed-exit__title">' + T.header + '</span>' +
      '<button type="button" class="creed-exit__close" aria-label="Zapri">×</button></div>' +
      '<div class="creed-exit__body">' +
      '<p class="creed-exit__h">' + T.title + '</p>' +
      '<p class="creed-exit__p">' + (trio ? T.bodyTrio : T.body) + '</p>' +
      '<button type="button" class="creed-exit__btn">' + (trio ? T.ctaTrio : T.cta) + '</button>' +
      '<button type="button" class="creed-exit__no">' + T.no + '</button>' +
      '</div></div>';

    function close() {
      overlay.classList.remove('is-open');
      setTimeout(function () { overlay.remove(); }, 250);
    }

    overlay.querySelector('.creed-exit__close').addEventListener('click', close);
    overlay.querySelector('.creed-exit__no').addEventListener('click', close);
    overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });

    overlay.querySelector('.creed-exit__btn').addEventListener('click', function () {
      var btn = this;
      btn.disabled = true;
      var go = function () { window.location.href = ROOT + 'cart'; };
      if (trio) { go(); return; }
      fetch(ROOT.replace(/\/$/, '') + '/discount/' + CODE).then(go).catch(go);
    });

    document.body.appendChild(overlay);
    requestAnimationFrame(function () { overlay.classList.add('is-open'); });
  }

  var armed = false;
  setTimeout(function () { armed = true; }, 15000); // prvih 15 s miru

  document.addEventListener('mouseout', function (e) {
    if (!armed) return;
    if (e.relatedTarget || e.toElement) return;
    if (e.clientY > 10) return;
    try { if (sessionStorage.getItem(FLAG)) return; } catch (err) { return; }
    if (document.querySelector('.creed-oto-overlay')) return; // OTO popup je odprt
    fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart && cart.item_count > 0 && !sessionStorage.getItem(FLAG)) show();
      })
      .catch(function () {});
  });
})();
